import { environment } from './environments/environment';

interface IAppVersion {
    appVersion: string;
    product: 'customer-dashboard' | 'admin-dashboard';
    env: string;
    build?: number;
    buildTime?: number;
}

const appInfo: IAppVersion = {
    appVersion: 'v2.2.2-alpha.1',
    product: 'customer-dashboard',
    env: environment.name,
    build: 100,
    buildTime: 1758714730197
};

export { appInfo, IAppVersion };
